import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

// Connects to data-controller="engage--tooltip"
// Positions tooltip near a target DOM element, handles auto-dismiss timeout.
export default class extends Controller {
  static targets = ["panel"]
  static values = {
    flowId: String,
    stepKey: String,
    targetSelector: String,
    autoTimeout: { type: Number, default: 0 },
  }

  #timer = null
  #abortController = null

  connect() {
    this.#abortController = new AbortController()
    void this.#show()
  }

  disconnect() {
    if (this.#timer) clearTimeout(this.#timer)
    this.#abortController?.abort()
  }

  async complete() {
    await this.#patch(
      `/api/v1/engage/flow_states/${this.flowIdValue}/complete_step`,
      {
        step_key: this.stepKeyValue,
      },
    )
    this.element.remove()
  }

  async dismiss() {
    if (this.#timer) clearTimeout(this.#timer)
    await this.#patch(`/api/v1/engage/flow_states/${this.flowIdValue}/dismiss`)
    this.element.remove()
  }

  // ── Private ──────────────────────────────────────────────────────────────

  async #show() {
    await this.#patch(`/api/v1/engage/flow_states/${this.flowIdValue}/start`)

    const el = document.querySelector(this.targetSelectorValue)
    if (!el || !this.hasPanelTarget) return

    const rect = el.getBoundingClientRect()
    const panel = this.panelTarget
    panel.style.top = `${rect.bottom + 8}px`
    panel.style.left = `${Math.min(rect.left, window.innerWidth - 272)}px`
    panel.style.display = ""

    if (this.autoTimeoutValue > 0) {
      this.#timer = setTimeout(() => void this.dismiss(), this.autoTimeoutValue)
    }
  }

  async #patch(url, body = null) {
    try {
      const options = { credentials: "include", responseKind: "json" }
      if (this.#abortController) options.signal = this.#abortController.signal
      if (body) options.body = body
      const response = await patch(url, options)
      if (!response.ok)
        console.error(`[Engage] API error ${response.statusCode}`, url)
      return response
    } catch (e) {
      if (e.name !== "AbortError") throw e
    }
  }
}
